import { Component, output, input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerScale } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'empathy-viewer-icon-button',
  templateUrl: 'icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class EmpathyViewerIconButtonComponent {
  style = input<'basic' | 'stroked'>('basic');
  color = input<'primary' | 'none'>('primary');
  disabled = input<boolean>(false);
  icon = input<IconDefinition>();
  loading = input<boolean>(false);
  loadingIcon = input<IconDefinition>(faSpinnerScale);
  size = input<'large' | 'medium' | 'small'>('medium');
  testId = input<string>();
  tooltip = input<string>();

  clicked = output<void>();
}
